import { render, staticRenderFns } from "./CouponPage.vue?vue&type=template&id=2f58e245&scoped=true&"
import script from "./CouponPage.vue?vue&type=script&lang=js&"
export * from "./CouponPage.vue?vue&type=script&lang=js&"
import style0 from "../../less/gift.less?vue&type=style&index=0&id=2f58e245&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f58e245",
  null
  
)

export default component.exports